<app-deprecated-modal [hideCloseButton]="true" [medium]="true" [closable]="false" #submissionModal>
    <div *ngIf="uploadStatus === uploadStatuses.ready" class="confirmation">
        <h3>{{ 'import.submissionModal.importReady' | translate }}</h3>
        <ul>
            <li>
                <mat-icon class="check" svgIcon="success"></mat-icon>
                {{ 'import.submissionModal.employeesAdded' | translate: { newEmployeesCount: newEmployeesCount } }}
            </li>
            <li>
                <mat-icon class="update" svgIcon="refresh"></mat-icon>
                {{
                    'import.submissionModal.employeesUpdated'
                        | translate: { updateEmployeesCount: updateEmployeesCount }
                }}
            </li>
        </ul>
        <p class="warning">{{ 'import.submissionModal.warning' | translate }}</p>
        <div class="buttons">
            <ui-button type="ghost" (click)="submissionModal.onClose()">{{
                'import.submissionModal.cancel' | translate
            }}</ui-button>
            <ui-button type="primary" (click)="confirmUpload()">{{
                'import.submissionModal.import' | translate
            }}</ui-button>
        </div>
    </div>

    <div *ngIf="uploadStatus === uploadStatuses.working" class="working">
        <div class="ui active centered inline loader"></div>
        <h3>{{ 'import.submissionModal.progressHeader' | translate }}</h3>
    </div>

    <div *ngIf="uploadStatus === uploadStatuses.finished" class="finished">
        <h3 class="check-container"><mat-icon svgIcon="success"></mat-icon></h3>
        <h3>{{ 'import.submissionModal.employeesImported' | translate: { totalImportCount: totalImportCount } }}</h3>
        <ui-button type="primary" url="/employees/directory"> {{ 'import.viewPeople' | translate }} </ui-button>
    </div>

    <div *ngIf="uploadStatus === uploadStatuses.failed" class="finished" data-cy="failureModal">
        <h3 class="check-container"><mat-icon svgIcon="warning"></mat-icon></h3>
        <h3>{{ 'import.importFailed' | translate }}</h3>
        <h4 *ngIf="totalImportCount > 0">
            {{ 'import.dataImportSuccessfulForXEmployees' | translate: { totalImportCount: totalImportCount } }}
        </h4>
        <h4 *ngIf="totalImportFailCount > 0">
            {{ 'import.dataImportFailedForXEmployees' | translate: { totalImportFailCount: totalImportFailCount } }}
        </h4>
        <ui-button *ngIf="totalImportCount > 0" type="primary" url="/employees/directory">
            {{ 'import.viewPeople' | translate }}
        </ui-button>
        <ui-button *ngIf="totalImportCount === 0" type="primary" (click)="reload()" data-cy="closeFailureModal">{{
            'close' | translate
        }}</ui-button>
    </div>
</app-deprecated-modal>

<ui-dialog
    #dependentFieldModal
    header="import.dependentFieldModal.header"
    size="small"
    primaryButtonLabel="close"
    (closing)="dependentFieldModal.open = false"
    (primaryButtonPressed)="dependentFieldModal.open = false"
    [open]="dependentFieldModal.open"
>
    <div class="dependent-field-body">
        <p>{{ 'import.dependentFieldModal.mainDescription' | translate }}</p>
        <p>{{ 'import.dependentFieldModal.groupsTitle' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.addressLine1' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.city' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.province' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.postalCode' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.country' | translate }}</p>
        <hr class="margin-top-2" />
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.compensationType' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.salary' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.hoursPerWeek' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.compensationEffectiveDate' | translate }}</p>
        <hr class="margin-top-2" />
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.paymentMethod' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.bankBranch' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.bankInstitution' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.bankAccount' | translate }}</p>
        <hr class="margin-top-2" />
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.lastDayWorkedOn' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.terminatedOn' | translate }}</p>
        <p class="margin-bottom-0">{{ 'import.dependentFieldModal.terminationReason' | translate }}</p>
        <p class="margin-top-3">{{ 'import.dependentFieldModal.errorsNote' | translate }}</p>
    </div>
</ui-dialog>

<ui-confirmation-dialog
    #confirmationDialog
    header="import.confirmationDialog.header"
    primaryButtonLabel="import.confirmationDialog.primaryButtonLabel"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    secondaryButtonType="ghost"
>
    <p [innerHTML]="'import.confirmationDialog.firstLine' | translate"></p>
    <p>{{ 'import.confirmationDialog.secondLine' | translate }}</p>
</ui-confirmation-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header title="import.importEmployeeData">
        <ui-button
            *ngIf="
                appSteps.isCurrentStep(uploadFileStep) &&
                importService.hasImportType('INTEGRATIONS') &&
                importService.IMPORT_CONFIGS.INTEGRATIONS as importFromIntegrations
            "
            class="buttons"
            type="outline"
            [routerLink]="importFromIntegrations.routerLink"
        >
            <mat-icon [svgIcon]="importFromIntegrations.icon"></mat-icon>
            {{ 'import.types.INTEGRATIONS.title.LONG' | translate }}</ui-button
        >
    </app-header>

    <app-steps
        #appSteps
        [steps]="[uploadFileStep, mapColumnsStep, mapValuesStep, reviewStep]"
        [beforePrevious]="confirmPrevious"
        [beforeNext]="confirmNext"
        (onNext)="trackNextStep($event)"
        (onPrevious)="trackPreviousStep($event)"
        (onPrimary)="onSave()"
    >
        <app-step #uploadFileStep step="import.uploadFileStep.menuTitle" [stepForm]="uploadFileForm">
            <app-segment-header title="import.uploadFileStep.title">
                <div class="buttons">
                    <ui-button *ngIf="canExportData" type="ghost" (click)="onExportEmployee()">{{
                        'import.uploadFileStep.exportData' | translate
                    }}</ui-button>
                    <ui-button type="primary" class="margin-right-2" [url]="importCsvTemplate" [externalLink]="true">{{
                        'import.uploadFileStep.downloadTemplate' | translate
                    }}</ui-button>
                </div>
            </app-segment-header>
            <h5 class="subheading" [innerHTML]="'import.uploadFileStep.importingNewEmployees' | translate"></h5>
            <h5
                class="subheading"
                *ngIf="canExportData"
                [innerHTML]="'import.uploadFileStep.updatingExistingEmployees' | translate"
            ></h5>
            <div class="file-upload-container">
                <div class="left-section">
                    <app-form-employees-import-upload-file #uploadFileForm (onFileUpload)="setColumnsAndRows($event)">
                    </app-form-employees-import-upload-file>
                </div>
            </div>

            <!--Tutorial Links-->
            <div class="migration-links">
                <h3>{{ 'import.uploadFileStep.helpfulLinks' | translate }}</h3>
                <ng-container *ngFor="let helpItem of helpItems">
                    <a href="{{ helpItem.link | i18nHelpCentre }}" target="_blank">
                        {{ helpItem.label | translate }}
                    </a>
                </ng-container>
            </div>
        </app-step>

        <app-step #mapColumnsStep step="import.mapColumnsStep.menuTitle" [stepForm]="mapColumnsForm">
            <div>
                <app-segment-header title="import.mapColumnsStep.title"></app-segment-header>
                <h5 class="subheading">{{ 'import.mapColumnsStep.subheading' | translate }}</h5>
                <app-form-import-employee-column-map
                    *ngIf="appSteps.isCurrentStep(mapColumnsStep)"
                    #mapColumnsForm
                    (isLoading)="onStepLoading($event)"
                >
                </app-form-import-employee-column-map>
            </div>
        </app-step>

        <app-step #mapValuesStep step="import.mapValuesStep.menuTitle" [stepForm]="mapValuesForm">
            <div>
                <app-segment-header title="import.mapValuesStep.title"></app-segment-header>
                <h5 class="subheading">{{ 'import.mapColumnsStep.subheading' | translate }}</h5>

                <app-form-employees-import-map-values
                    *ngIf="appSteps.isCurrentStep(mapValuesStep)"
                    #mapValuesForm
                    (isLoading)="onStepLoading($event)"
                >
                </app-form-employees-import-map-values>
            </div>
        </app-step>

        <app-step
            #reviewStep
            step="import.reviewStep.menuTitle"
            [stepForm]="reviewForm"
            [ngClass]="{ fullscreen: reviewFormFullscreen }"
        >
            <div>
                <app-segment-header title="import.reviewStep.title"></app-segment-header>
                <h5 class="subheading">
                    {{ 'import.reviewStep.subheading' | translate }}
                    <a (click)="$event.preventDefault(); openDependentFieldModal()" href="#">{{
                        'import.reviewStep.subheadingErrorLink' | translate
                    }}</a>
                </h5>
                <app-form-employees-import-review
                    *ngIf="appSteps.isCurrentStep(reviewStep)"
                    #reviewForm
                    (isLoading)="onStepLoading($event)"
                    (fullscreenEnabled)="reviewFormFullscreen = $event"
                >
                </app-form-employees-import-review>
            </div>
        </app-step>
    </app-steps>
</div>
